import { component } from "picoapp";

export const updateReviewCountText = component((node: HTMLElement) => {
  const updateText = (_node: HTMLElement) => {
    const totalCountFormat =
      node.getAttribute("data-product-rating-count") + "+";

    _node.innerHTML = totalCountFormat;
  };

  const observer = new MutationObserver((mutationList) => {
    for (const mutation of mutationList) {
      if (mutation.type === "childList") {
        mutation.addedNodes.forEach((addedNode: HTMLElement) => {
          if (
            addedNode instanceof HTMLElement &&
            addedNode.querySelector(".junip-product-summary-review-count")
          ) {
            updateText(
              addedNode.querySelector(".junip-product-summary-review-count")
            );
          }
        });
      }
    }
  });

  observer.observe(node, { childList: true, subtree: true });

  return () => {
    observer.disconnect();
  };
});
